import { useState } from 'react';
import { NJButton, NJHeading, NJText } from '@engie-group/fluid-design-system-react';
import { UMSegmentedControl } from '../../urbanmap/_components';

export function Wireframes() {
  const [navigation, setNavigation] = useState('Arborescence');
  const [rules, setRules] = useState('Carte + inspecteur');
  return <section className="sp-settings sp-stack">
    <NJHeading as="h1">Plan · revue du parcours</NJHeading>
    <NJText>Hypothèses UX non encore validées. Les règles métier sont celles de l’atelier.</NJText>
    <NJText as="div"><strong>1. Retrouver un scénario et ses plans</strong></NJText>
    <UMSegmentedControl options={['Arborescence', 'Cartes séquentielles']} value={navigation} onChange={setNavigation} />
    <div className="sp-wire-row">
      {navigation === 'Arborescence' ? <>
        <div className="sp-wire">Projet<br />└ Scénario A<br />　├ Plan chaleur<br />　└ Plan froid<br />└ Scénario B</div>
        <div className="sp-wire">Espace du scénario ou du plan sélectionné</div>
      </> : <>
        <div className="sp-wire">Projet → cartes des scénarios</div>
        <div className="sp-wire">Scénario → hypothèses et cartes des plans</div>
      </>}
    </div>
    <NJText as="div"><strong>2. Paramétrer les routes et les départs</strong></NJText>
    <UMSegmentedControl options={['Carte + inspecteur', 'Liste puis carte']} value={rules} onChange={setRules} />
    <div className="sp-wire-row">
      <div className="sp-wire">{rules === 'Carte + inspecteur' ? 'Carte : sélection du tronçon, snapping, centrale et liaison' : 'Liste : types, pondérations et exceptions'}</div>
      <div className="sp-wire">{rules === 'Carte + inspecteur' ? 'Inspecteur : type, règle héritée, mode local prioritaire' : 'Ouvrir la carte pour localiser ou dessiner'}</div>
    </div>
    <NJText as="div"><strong>3. Créer un plan</strong> → nom, chaleur/froid, sélection et phasage des abonnés → génération.</NJText>
    <NJText as="div"><strong>4. Compléter le plan</strong> → phasage des canalisations, dessin manuel, alertes non bloquantes.</NJText>
    <NJText as="div"><strong>5. Recalculer</strong> → choix des hypothèses → confirmation de suppression manuelle → succès ou conservation intégrale en cas d’échec.</NJText>
    <NJButton label="Ouvrir le prototype · variantes A par défaut" href="?view=prototype" />
  </section>;
}
